import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { IVideoPlayer } from '@cap/share/src/components/VideoPlayer';
import { heartbeat } from '@cap/share/src/apis/courseDetail';
import { RootState } from '@/store';
import { IReportData } from './utils/type';
import { getTenantInfo } from '../../utils/func';

interface IVideoModuleState {
  videoPlayer: IVideoPlayer;
}

const initialState: IVideoModuleState = {
  videoPlayer: {
    triggerPlay: () => {},
    stopPlay: () => {},
  },
};

export const reportProgress = createAsyncThunk(
  'courseDetailStore/reportProgress',
  async (props: IReportData, { getState }) => {
    const { tenant } = props;
    try {
      const tenantInfo = getTenantInfo(tenant, getState);
      const res = await heartbeat(props, tenantInfo);
      return res.data;
    } catch (error: any) {
      return null;
    }
  },
);

const videoModuleSlice = createSlice({
  name: 'videoModule',
  initialState,
  reducers: {
    setVideoPlayer: (state, action) => {
      state.videoPlayer = action.payload;
    },
  },
});

export default videoModuleSlice.reducer;

export const { setVideoPlayer } = videoModuleSlice.actions;
export const selectVideoPlayer = (state: RootState) => state.detailCourseData.videoModule.videoPlayer;
